import { Routes } from '@angular/router';

export const respondentsRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./respondents.component').then((m) => m.RespondentsComponent),
  },
  {
    path: ':guid',
    loadComponent: () =>
      import('./respondent-detail/respondent-detail.component').then(
        (m) => m.RespondentDetailComponent,
      ),
  },
];
